//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Services
import { requestGetRoleCategories, requestGetUserRoles } from "services/settings/roleAdmin/relatedToRoleAdmin";
import { filterCampusVirtual, requestGetAllCampus } from "services/general";
import { throwError } from "services/helpers";
//#endregion

const useDataRelatedToRoles = ({
    loadingRequest,
    setFatalError
}) => {
    //#region States
    const [categoryList, setCategoryList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [campusList, setCampusList] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        loadingRequest.show();
        Promise.all([
            fillCategoryList(),
            fillRoleList(),
            fillCampusList()
        ])
        .catch(() => setFatalError(true))
        .finally(() => loadingRequest.hide());
    }, []);
    //#endregion
    //#region Functions
    const fillCategoryList = async () => {
        const fetchData = await requestGetRoleCategories();
        throwError(fetchData);
        setCategoryList(fetchData);
    }
    const fillRoleList = async () => {
        const fetchData = await requestGetUserRoles();
        throwError(fetchData);
        setRoleList(fetchData);
    }
    const fillCampusList = async () => {
        const fetchData = await requestGetAllCampus();
        throwError(fetchData);
        setCampusList(filterCampusVirtual(fetchData));
    }
    return {
        categoryList, 
        roleList,
        campusList
    };
}

export default useDataRelatedToRoles;